import db from "../../../../api/mongodb"

export const fetchPrivacySettings=(safeAPId, setLoading,setFormDataFields, setPrivacySettings)=>{
    db.get(`/api/safeAPs/${safeAPId}/savedFormData`)
    .then((response)=>{
        // console.log(response.data.formDataFileds)
        setFormDataFields(response.data.formDataFields)
        setPrivacySettings(response.data.privacySettings)
        setLoading(false)
    })
    .catch((err)=>{
        setLoading(false)
    })
}

export const savePrivacySettings = (safeAPId,privacySettings, setLoading, setMessage)=>{
    db.put(
        `api/safeAPs/${safeAPId}`,
        {
            privacySettings: privacySettings,
        },
        {
            headers: {
                Authorization: `${localStorage.getItem("token")}`,
            },
        }
    ).then((response)=>{
        // console.log(response.data.formDataFileds)
        setMessage("Privacy settings updated!")
        setLoading(false)
    })
    .catch((err)=>{
        setMessage("Privacy settings could not be updated, please try again")
        setLoading(false)
    })
}